import React, { useState, useEffect, useContext, useCallback } from "react";
import Weather from "./components/Weather";
import UsefulLinks from "./components/UsefulLinks";
import NavBar from "./components/NavBar";
import PageHolder from "./components/PageHolder";
import { createGlobalStyle } from "styled-components";
import styled from "styled-components";

const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0;
    height: 100%;
    width: 100%;
    font-family: monospace;
    font-size: calc(5px + 2vmin);
    transition-duration: 0.2s;
    overflow: hidden;
  };
  a {
    text-decoration: none;
    transition-duration: 0.2s;
  };
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
`;

const PageBackground = styled.div`
  background-color: #282c34;
  background-image: url("https://source.unsplash.com/random/1600x900");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transform: scale(1.1);
  margin: 0;
  padding: 0;
  min-height: 100vh;
  min-width: 100vw;
  filter: blur(6px) drop-shadow(0px 0px 0px black);
  position: absolute;
  z-index: 0;
`;

const AppContainer = styled.div`
  min-height: 100vh;
  min-width: 100vw;
`;

const AppHeader = styled.header`
  min-height: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 5vmin);
  color: white;
  z-index: 10;
`;

const AppRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0;
  padding: 0;
  z-index: 10;
`;

function App() {
  const [page, setPage] = useState(0);
  const setPageNr = useCallback(index => {
    setPage(index);
  }, []);
  return (
    <AppContainer>
      <GlobalStyle />
      <PageBackground></PageBackground>
      <AppHeader>
        {/* <NavBar setPageNr={setPageNr.bind(this)}></NavBar> */}
      </AppHeader>
      <UsefulLinks></UsefulLinks>
      <AppRow>
        <PageHolder pageNr={page}></PageHolder>
      </AppRow>
      <Weather></Weather>
    </AppContainer>
  );
}

export default App;
